import { observable } from "mobx";

export default class PossibleExemptionRegistrationResponse {
  @observable
  licensePlate: string;

  @observable
  possibleExemption: string;
}
